import { CURRENCY_FORMAT_FULL_FIGURES, CURRENCY_FORMAT_LAKH, CURRENCY_FORMAT_MN, CURRENCY_FORMAT_BN, CURRENCY_FORMAT_K, CURRENCY_FORMAT_CR } from '../../constants';
import { DEFUALT_CONVERION_LIMIT } from './constants';
export const getSpeedometerValues = (reportDetails, totalScore) => {
    let speedometerData, mediumRiskGradeData = getMediumRiskLevelData(reportDetails),
        lowriskGradeData = getLowRiskLevelData(reportDetails),
        highRiskGradeData = getHighRiskLevelData(reportDetails);

    speedometerData = {
        totalScore: totalScore,
        min: reportDetails[0].min,
        max: reportDetails[reportDetails.length - 1].max,
        mediumRiskValue: (mediumRiskGradeData.length > 0) ? {
            min: mediumRiskGradeData[0].min,
            max: mediumRiskGradeData[mediumRiskGradeData.length - 1].max
        } : {
                min: reportDetails.riskGradeSummaryList[0].min,
                max: reportDetails.riskGradeSummaryList[0].min
            },
        lowRiskValue: (lowriskGradeData.length > 0) ? {
            min: lowriskGradeData[0].min,
            max: lowriskGradeData[lowriskGradeData.length - 1].max
        } : {
                min: reportDetails[0].min,
                max: reportDetails[0].min,
            },
        highRiskValue: (highRiskGradeData.length > 0) ? {
            min: highRiskGradeData[0].min,
            max: highRiskGradeData[highRiskGradeData.length - 1].max
        } : {
                min: reportDetails[0].min,
                max: reportDetails[0].min,
            }
    }
    return speedometerData;
}

const getMediumRiskLevelData = (reportDetails) => {
    let mediumRiskGrade = [];
    reportDetails.map(item => {
        if (item.riskLevel === 'MEDIUM') {
            mediumRiskGrade.push(item)
        }
    })
    return mediumRiskGrade
}
const getLowRiskLevelData = (reportDetails) => {
    let lowRiskGrade = [];
    reportDetails.map(item => {
        if (item.riskLevel === 'LOW') {
            lowRiskGrade.push(item)
        }
    })
    return lowRiskGrade
}
const getHighRiskLevelData = (reportDetails) => {
    let highRiskGrade = [];
    reportDetails.map(item => {
        if (item.riskLevel === 'HIGH') {
            highRiskGrade.push(item)
        }
    })
    return highRiskGrade
}
export const getRampValues = (rampRawData) => {
    let totalScaleDifference = rampRawData.max - rampRawData.min, rampValues;
    rampValues = {
        highData: ((rampRawData.highRiskValue.max - rampRawData.highRiskValue.min) / totalScaleDifference).toFixed(1),
        mediumData: (((rampRawData.mediumRiskValue.max - rampRawData.mediumRiskValue.min) / totalScaleDifference) + ((rampRawData.highRiskValue.max - rampRawData.highRiskValue.min) / totalScaleDifference)).toFixed(1),
        lowData: (((rampRawData.lowRiskValue.max - rampRawData.lowRiskValue.min) / totalScaleDifference) + ((rampRawData.mediumRiskValue.max - rampRawData.mediumRiskValue.min) / totalScaleDifference) + ((rampRawData.highRiskValue.max - rampRawData.highRiskValue.min) / totalScaleDifference)).toFixed(1)
    }
    return rampValues
}
export const formatCurrency = (number, caseType, decimalDigits = 2) => {
    return new Intl.NumberFormat('en-IN', (caseType === 'INTERNATIONAL' ? { minimumFractionDigits: 0, maximumFractionDigits: decimalDigits } : { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: decimalDigits})).format(number);
}

export const formatNumbers = (event, data) => {
    let tempData = ''
    switch (event.target.innerText) {
        case CURRENCY_FORMAT_K:
            tempData = formatCurrency(Number(data) / 1000);
            break;
        case CURRENCY_FORMAT_LAKH:
            tempData = formatCurrency(Number(data) / 100000);
            break;
        case CURRENCY_FORMAT_CR:
            tempData = formatCurrency(Number(data) / 10000000);
            break;
        case CURRENCY_FORMAT_MN:
            tempData = formatCurrency(Number(data) / 1000000);
            break;
        case CURRENCY_FORMAT_BN:
            tempData = formatCurrency(Number(data) / 1000000000);
            break;
        case CURRENCY_FORMAT_FULL_FIGURES:
        default:
            tempData = formatCurrency(data, 0);
    }
    return tempData;
}

export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}

export const formatPaymentNumbers = (text, valueData, paymentData) => {
    const tempLevelOne = copyArray(paymentData.levelOneKeyFields)
    const tempLevelTwo = copyArray(paymentData.levelTwoKeyFields)
    let tempPayment = (tempLevelOne).concat(tempLevelTwo);
    for (let i = 0; i < tempPayment.length; i++) {
        for (let j = 0; j < valueData.length; j++) {
            if (valueData[j].name === tempPayment[i].name) {
                let temp = tempPayment[i].value;
                valueData[j].value = formatPaymentData(text, temp)
                if (valueData[j].monthlyDataList) {
                    for (let k = 0; k < (valueData[j].monthlyDataList).length; k++) {
                        if (valueData[j].monthlyDataList[k].value) {
                            valueData[j].monthlyDataList[k].value = formatPaymentData(text, tempPayment[i].monthlyDataList[k].value)
                        }
                    }
                }
            }
        }
    }
    return valueData
}


const formatPaymentData = (type, data) => {
    let tempData = ''
    switch (type) {
        case CURRENCY_FORMAT_K:
            tempData = (data > DEFUALT_CONVERION_LIMIT) ? formatPaymentValues(Number(data) / 1000) + ' K' : formatPaymentValues(Number(data));
            break;
        case CURRENCY_FORMAT_LAKH:
            tempData = (data > DEFUALT_CONVERION_LIMIT) ? formatPaymentValues(Number(data) / 100000) + ' L' : formatPaymentValues(Number(data));
            break;
        case CURRENCY_FORMAT_CR:
            tempData = (data > DEFUALT_CONVERION_LIMIT) ? formatPaymentValues(Number(data) / 10000000) + ' Cr' : formatPaymentValues(Number(data));
            break;
        case CURRENCY_FORMAT_MN:
            tempData = (data > DEFUALT_CONVERION_LIMIT) ? formatPaymentValues(Number(data) / 1000000) + ' Mn' : formatPaymentValues(Number(data));
            break;
        case CURRENCY_FORMAT_BN:
            tempData = (data > DEFUALT_CONVERION_LIMIT) ? formatPaymentValues(Number(data) / 1000000000) + ' Bn' : formatPaymentValues(Number(data));
            break;
        case CURRENCY_FORMAT_FULL_FIGURES:
            tempData = formatPaymentValues(Number(data))
            break;
        default:
            tempData = (data);
    }
    return tempData;
}

export const formatPaymentValues = (number, decimalDigits = 1) => {
    return new Intl.NumberFormat('en-IN', { maximumFractionDigits: decimalDigits }).format(number);
}


export const getPaymentValue = (paymentData, paymentValue) => {
    let tempValue = paymentValue.find(x => x.name === paymentData.name).value;
    return tempValue
}

export const formatInitialPaymentValues = (paymentValue, paymentData) => {
    let tempValueData = formatPaymentNumbers(CURRENCY_FORMAT_K, paymentValue, paymentData);
    return tempValueData
}

export const sectionDetails = (sectionData, sectionNo) => {
    let section;
    sectionData.forEach(element => {
        if (element.computedSectionId === sectionNo) {
            section = element;
        }
    })
    return section
}